/**
 * Microsoft Teams Logo SVG Component
 *
 * Microsoft Teams brand logo
 */

interface TeamsLogoProps {
  className?: string;
}

export function TeamsLogo({ className }: TeamsLogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Person silhouette (right) */}
      <circle cx="22.5" cy="9" r="2.5" fill="#5059C9" />
      <path
        d="M19.5 13h6a1.5 1.5 0 0 1 1.5 1.5V20a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3v-5.5a1.5 1.5 0 0 1 1.5-1.5z"
        fill="#5059C9"
      />
      {/* Person silhouette (front, larger) */}
      <circle cx="16" cy="7.5" r="3" fill="#7B83EB" />
      <path
        d="M11 12h10a2 2 0 0 1 2 2v7a4 4 0 0 1-4 4h-6a4 4 0 0 1-4-4v-7a2 2 0 0 1 2-2z"
        fill="#7B83EB"
      />
      {/* Chat bubble accent */}
      <path
        d="M6 15h8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H8l-2 2v-2H6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1z"
        fill="#4F52B2"
      />
    </svg>
  );
}
